import { render, staticRenderFns } from "./tradeconfirm.vue?vue&type=template&id=04c5203a&scoped=true"
import script from "./tradeconfirm.vue?vue&type=script&lang=js"
export * from "./tradeconfirm.vue?vue&type=script&lang=js"
import style0 from "./tradeconfirm.vue?vue&type=style&index=0&id=04c5203a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5203a",
  null
  
)

export default component.exports